module.exports = __webpack_public_path__ + "static/img/bgimg1.9a5c070f.jpg";